import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-label',
  templateUrl: './formly-label.component.html',
  styleUrls: [],
})
export class FormlyLabelComponent extends FieldType {}
